import { LineData } from "components/charting/types/Chart.types";
import { createContext } from "react";

export type OneRepMaxChartDataContextType = LineData[];

const OneRepMaxChartDataContext = createContext<OneRepMaxChartDataContextType | undefined>(undefined);
OneRepMaxChartDataContext.displayName = "OneRepMaxChartDataContext";

export default OneRepMaxChartDataContext;
